import type { PopoverPlacement, PopoverProps } from '@creditornot/cb-popover';
import { Popover } from '@creditornot/cb-popover';
import * as React from 'react';
import styled from 'styled-components';

export type { PopoverPlacement as PopoverPlacement };

export type RenderProps = {
  children?: React.ReactNode;
  closePopover: () => void;
  disabled?: boolean;
  isOpen: boolean;
  openPopover: () => void;
};

export type Props = {
  children: React.FC<RenderProps>;
  className?: string;
  content?: React.ReactNode | React.FunctionComponent<RenderProps>;
  contentZIndex?: number;
  disabled?: boolean;
  onCloseStart?: () => void;
  placement?: PopoverPlacement;
  portalElement?: PopoverProps['portalElement'];
  rendering?: PopoverProps['rendering'];
  style?: React.CSSProperties;
};

const Root = styled.div`
  display: inline-block;
`;

const DatePickerPopover = ({
  children,
  className,
  content,
  contentZIndex,
  disabled,
  onCloseStart,
  placement = 'bottom-start',
  portalElement,
  rendering,
  style,
}: Props) => {
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  return (
    <Popover
      content={
        typeof content === 'function'
          ? content({
              disabled,
              closePopover: () => setPopoverOpen(false),
              openPopover: () => setPopoverOpen(true),
              isOpen: popoverOpen,
            })
          : content
      }
      offset={4}
      onCloseStart={onCloseStart}
      onOpenChange={setPopoverOpen}
      open={disabled ? false : popoverOpen}
      placement={placement}
      portalElement={portalElement}
      renderArrow={false}
      rendering={rendering}
      zIndex={contentZIndex}
    >
      {({ refProps }) => (
        <Root role="group" {...refProps} className={className} style={style}>
          {children({
            disabled,
            isOpen: popoverOpen,
            closePopover: () => setPopoverOpen(false),
            openPopover: () => setPopoverOpen(true),
          })}
        </Root>
      )}
    </Popover>
  );
};

export default DatePickerPopover;
